// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._55SufBs9x{width:100%}._1csTWJArx{}._1Fa5vphex{box-sizing:border-box}._65eNK6BAx{display:flex;flex:0 1 auto;flex-direction:column;overflow:hidden}._1xBgOHaIx{font-size:12px;flex-wrap:nowrap}._1xBgOHaIx ._1Fa5vphex{flex:0 0 28px}._1FY1cTtwx{font-size:12px}._1FY1cTtwx ._1csTWJArx{font-size:14px}._1FY1cTtwx ._1Fa5vphex{flex:0 0 38px}._4RX8Vwlqx{font-size:14px}._4RX8Vwlqx ._1csTWJArx{font-size:16px}._4RX8Vwlqx ._1Fa5vphex{flex:0 0 53px}\n", "",{"version":3,"sources":["webpack://client/shared/device-card/device-card.scss"],"names":[],"mappings":"AAAwmB,YAAM,UAAU,CAAC,YAAoD,CAAC,YAAK,qBAAqB,CAAC,YAAM,YAAY,CAAC,aAAa,CAAC,qBAAqB,CAAC,eAAe,CAAC,YAAO,cAAc,CAAC,gBAAgB,CAAC,wBAAY,aAAa,CAAC,YAAQ,cAAc,CAAC,wBAAc,cAAc,CAAC,wBAAa,aAAa,CAAC,YAAO,cAAc,CAAC,wBAAa,cAAc,CAAC,wBAAY,aAAa","sourcesContent":[":export{tabletScreen:768px;smallScreen:1100px;mediumScreen:1300px;largeScreen:1500px;azure:#006fc8;cyan:#1FAECE;primaryText:var(--primary-text);secondaryText:var(--secondary-text);chartGridColor:var(--ui-divider);gray10:#dedede;msDarkBlue:#002050;amberLight2:#F7E28B;violetLight2:#CEC0EC;tealLight3:#CFECE8;bannerBlue:var(--banner-blue);spaceXXS:4px;spaceXS:8px;spaceS:16px;spaceM:20px;spaceXM:24px;spaceL:32px;spaceXL:40px;spaceXXL:60px;panelSlideDuration:200ms;panelFadeDuration:100ms;ccBannerHeight:46px;chartCyan:var(--charts-cyan);chartMapBorders:var(--charts-map-border);chartMapBgDefault:var(--charts-map-bg)}.grid{width:100%}.name{composes:ellipsize from '../styles/utils.scss'}.img{box-sizing:border-box}.data{display:flex;flex:0 1 auto;flex-direction:column;overflow:hidden}.small{font-size:12px;flex-wrap:nowrap}.small .img{flex:0 0 28px}.medium{font-size:12px}.medium .name{font-size:14px}.medium .img{flex:0 0 38px}.large{font-size:14px}.large .name{font-size:16px}.large .img{flex:0 0 53px}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"grid": "_55SufBs9x",
	"name": "_1csTWJArx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["ellipsize"] + "",
	"img": "_1Fa5vphex",
	"data": "_65eNK6BAx",
	"small": "_1xBgOHaIx",
	"medium": "_1FY1cTtwx",
	"large": "_4RX8Vwlqx"
};
export default ___CSS_LOADER_EXPORT___;
